import { useMemo } from 'react';

import { DocumentStatusEnum } from 'common/document/enums/document-status.enum';

import { ReactComponent as ErrorIcon } from 'assets/images/document-status/error.svg';
import { ReactComponent as WarningIcon } from 'assets/images/document-status/warning.svg';
import { ReactComponent as InfoIcon } from 'assets/images/document-status/info.svg';
import { ReactComponent as SuccessIcon } from 'assets/images/document-status/success.svg';
import { ReactComponent as WaitingIcon } from 'assets/images/document-status/waiting.svg';

type InputProps = {
  status: DocumentStatusEnum | undefined;
};

export const DocumentStatusIcon = ({ status }: InputProps) => {
  const Status = useMemo(() => {
    switch (status) {
      case DocumentStatusEnum.NEEDS_REVIEW:
      case DocumentStatusEnum.UPLOADED:
        return WaitingIcon;
      case DocumentStatusEnum.REJECTED:
        return ErrorIcon;
      case DocumentStatusEnum.APPROVED:
        return SuccessIcon;
      case DocumentStatusEnum.REQUESTED:
        return WarningIcon;
      default:
        return InfoIcon;
    }
  }, [status]);

  return <Status />;
};
